module.exports = __webpack_public_path__ + "img/749DCBE9905D3844.ba244cf2.png";